import { render, staticRenderFns } from "./IconMenuAlt2Solid.vue?vue&type=template&id=31a564b8"
import script from "./IconMenuAlt2Solid.vue?vue&type=script&lang=js"
export * from "./IconMenuAlt2Solid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports